// extracted by mini-css-extract-plugin
export default {"header":"return-section_header__GXEGh","title":"return-section_title__HZLd7","returnItemWrapper":"return-section_returnItemWrapper__x4of3"};